import React from "react";

export default function nl2br(text) {
	return text.split("\\n").map((item, key) => {
		return (
			<span key={key}>
				{item}
				<br />
			</span>
		);
	});
}



// WEBPACK FOOTER //
// ./src/utils/nl2br.js